// Application.js
var Application = pc.createScript('application');
//var self = null;
var firstInitLoad = false;

Application.prototype.initialize = function() {

    //setFillMode();
    initializeResize();
    //document.body.style.backgroundColor = "#EBEBEBFF";
    if (pc.platform.mobile) {
        window.addEventListener("resize", () => {
            if (window.innerWidth < window.innerHeight) {
                document.getElementById("application-canvas").style.height = "100%";
                document.getElementById("application-canvas").style.width = "100%";

            }
        });
    }

    var style = document.createElement('style');
    document.head.appendChild(style);
    style.innerHTML = "canvas{-webkit-touch-callout:none;-webkit-user-select:none -khtml-user-select:none;-moz-user-select:none;-ms-user select:none;user-select:none;outline:0;-webkit-tap-highlight-color:rgba(255,255255,0)";
    style.innerHTML = "body{-webkit-touch-callout:none;-webkit-user-select:none -khtml-user-select:none;-moz-user-select:none;-ms-user select:none;user-select:none;outline:0}";
    this.app.mouse.disableContextMenu();
    //self = this;

    this._loadingScene = false;

    this.app.on('game:Ready',this.LoadSceneData,this);
};

Application.prototype.LoadSceneData = function(sceneName){
    
    var menu = this.app.scenes.find(sceneName);
    this.app.off('game:Ready',this);
    this.app.scenes.loadSceneData(menu, function (err, sceneItem) {
        if (err) {
            console.error(err);
        } else {
            var rootChildren = this.app.root.children;
            while (rootChildren.length > 0) {
                rootChildren[0].destroy();
            }

            this.app.scenes.loadSceneHierarchy(menu);
            this.app.scenes.loadSceneSettings(menu);

            this.app.scenes.unloadSceneData(menu);
        }
    }.bind(this));
};




